import { render, staticRenderFns } from "./AppDetalleEmpleado.vue?vue&type=template&id=8e04892a"
import script from "./AppDetalleEmpleado.vue?vue&type=script&lang=js"
export * from "./AppDetalleEmpleado.vue?vue&type=script&lang=js"
import style0 from "./AppDetalleEmpleado.vue?vue&type=style&index=0&id=8e04892a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports